module.exports = __webpack_public_path__ + "img/jelly1.30b03ed3.jpg";